import { useMemo } from 'react';

import { ContextualGroupsConfigType, VisibilitySettingsValueType } from '../types';
import { parseVisibilitySettingsRestrictionConfig } from '../utils';
import useVisibilitySettingsActions from './useVisibilitySettingsActions';

export type UseVisibilitySettingsReturnType = ReturnType<typeof useVisibilitySettings>;

const useVisibilitySettings = (
  props: Pick<VisibilitySettingsValueType, 'value' | 'onChange'> & {
    contextualGroupsConfig?: ContextualGroupsConfigType;
  },
) => {
  const { value } = props;

  const { groupIds, contextualGroups, userIds } = useMemo(
    () => parseVisibilitySettingsRestrictionConfig(value),
    [value],
  );

  const {
    onAccessTypeChange,
    onRestrictionConfigChange,
    onRemoveUser,
    onRemoveGroup,
    onAddGroup,
    onAddMultipleGroups,
    onAddUser,
  } = useVisibilitySettingsActions(props);

  return {
    values: { userIds, groupIds, contextualGroups },
    methods: {
      onAccessTypeChange,
      onRestrictionConfigChange,
      onRemoveUser,
      onRemoveGroup,
      onAddGroup,
      onAddMultipleGroups,
      onAddUser,
    },
  };
};

export default useVisibilitySettings;
